import type { ChannelKeyName, IMmxChannel } from "app/constants/MmxChannels";
import { MMX_CHANNELS } from "app/constants/MmxChannels";

export interface IMmxSegmentMapping {
    display: string;
    dataKey: ChannelKeyName;
    tooltip?: string;
}

const toSegmentMapping = (channel: IMmxChannel): IMmxSegmentMapping => ({
    display: channel.display,
    dataKey: channel.key,
    ...(channel.tooltip ? { tooltip: channel.tooltip } : {}),
});

/**
 * Channel mapping in the overview / base order, derived from {@link MMX_CHANNELS}.
 * Shared by the "Channels overview" bar chart and the "Marketing channels traffic
 * and engagement" line chart (legend + series) so both stay in the same order.
 */
export const SegmentsMmxChannelsMapping: IMmxSegmentMapping[] = MMX_CHANNELS.map(toSegmentMapping);
